export function is3dTypeUtils(fileName: string): boolean {
    const extensions: string[] = ['.stl', '.obj', '.ply'];
    return extensions.some((ext) => fileName.endsWith(ext) || fileName.includes(ext));
}